"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startRuntimeErrorCollection = void 0;
var browser_core_1 = require("@datadog/browser-core");
var reportRawError_1 = require("../../reportRawError");
function startRuntimeErrorCollection(configuration, sender, rawErrorObservable) {
    if (rawErrorObservable === void 0) { rawErrorObservable = new browser_core_1.Observable(); }
    if (configuration.forwardErrorsToLogs) {
        (0, browser_core_1.trackRuntimeError)(rawErrorObservable);
    }
    var rawErrorSubscription = rawErrorObservable.subscribe(function (rawError) { return (0, reportRawError_1.reportRawError)(rawError, sender); });
    return {
        stop: function () {
            rawErrorSubscription.unsubscribe();
        },
    };
}
exports.startRuntimeErrorCollection = startRuntimeErrorCollection;
//# sourceMappingURL=runtimeErrorCollection.js.map